import dayjs from 'dayjs';
import { columns } from './column';
import { Box } from '@mui/material';
import main from './main.module.scss';
import CustomCollapse from './collapse';
import CustomTable from 'components/table';
import { useEffect, useState } from 'react';
import useDebounce from 'hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowDropdown } from 'react-icons/io';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import notificationService from 'services/notification';
import { useHomeQuery } from 'services/query/home/use-home-list';
import { Tag, CustomButton, GlobalContainer, DeleteModal } from 'components';

const Main = () => {
  const navigate = useNavigate();
  const [date, setDate] = useState();
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [limit, setLimit] = useState('100');
  const [show, setShow] = useState<any>();
  const [search, setSearch] = useState('');
  const [deleteModal, setDeleteModal] = useState<any>(null);
  const debounceSearch = useDebounce(search, 300);
  const { isLoading, isError, data, refetch } = useHomeQuery({
    page,
    limit,
    search: debounceSearch ? debounceSearch : undefined,
    control_date: date ? date : dayjs(new Date()).format('YYYY-MM-DD'),
  });

  const handleToggle = () => {
    if (show) {
      setOpen(!open);
    }
  };

  useEffect(() => {
    if (date || search) {
      setPage(1);
    }
  }, [date, search]);

  const openToCase = () => {
    if (show?.id) {
      navigate(`/case-management/${show?.id}`, {
        state: { id: show?.id, policy: show?.policy?.id },
      });
    }
  };

  const changeStatus = (e: any) => {
    notificationService
      .update(e, { status: 'done' })
      .then((res) => {
        setShow({ ...show, status: res.status });
        setDeleteModal(false);
        refetch();
      })
      .catch((err: any) => console.log('home res err', err));
  };

  const handleEvent = (e: any, count: number) => {
    if (count === 1) {
      setOpen(true);
      setShow({ updateStatusID: e.id, ...e.case, status: e.status });
    } else if (count === 2) {
      navigate(`/case-management/${e.case.id}`, {
        state: { id: e.case.id, policy: e?.case?.policy?.id },
      });
    }
  };

  return (
    <GlobalContainer
      setSearch={setSearch}
      search={search}
      setDate={setDate}
      btnHidden
      dateHidden={false}
      date={date}>
      <Box mt='20px'>
        <Box className={main.collapse_container}>
          <Box className={main.card} style={{ marginBottom: !open ? '15px' : '0' }}>
            <Box className={main.card_head_left}>
              <span className={main.card_title}>{!open ? 'Карточка клиент' : `№ ${show?.id}`}</span>
              {open && <Tag variant='activeRounded'>{!open ? '' : show?.status}</Tag>}
            </Box>
            <Box className={main.card_head_right}>
              {open && (
                <CustomButton
                  text='Закрыть уведомление'
                  iconEnd={false}
                  disabled={show?.status === 'done'}
                  onClick={(e: any) => {
                    e.preventDefault();
                    setDeleteModal(show?.updateStatusID);
                  }}
                  background={'transparent'}
                  border={show?.status === 'done' ? false : true}
                  color={'#005aa9'}
                />
              )}
              {open && (
                <CustomButton
                  text='Открыть дело'
                  iconEnd={<AiOutlinePlusCircle size={21} />}
                  onClick={openToCase}
                />
              )}

              <IoIosArrowDropdown onClick={handleToggle} className={main.card_icon} />
            </Box>
          </Box>

          <CustomCollapse open={open} data={show} />
        </Box>

        <CustomTable
          page={page}
          limit={limit}
          error={isError}
          refetch={refetch}
          height='300px'
          data={data || []}
          setPage={setPage}
          columns={columns}
          loading={isLoading}
          setLimit={setLimit}
          styles={{ mt: '0' }}
          handleEvent={(e: any, i: any) => handleEvent(e, i.detail)}
          noDataText={'Уведомления по выбранной дате отсутсвуют, выберите другую дату.'}
        />

        {deleteModal && (
          <DeleteModal
            okText='Ok'
            headerText='Подтвердить изменять статус'
            text='Вы действительно хотите закрыть уведомления?'
            click={() => changeStatus(deleteModal)}
            open={deleteModal}
            handleCancel={() => setDeleteModal(null)}
          />
        )}
      </Box>
    </GlobalContainer>
  );
};

export default Main;
